import { render } from "./Checkboard.vue?vue&type=template&id=1af7c312"
import script from "./Checkboard.vue?vue&type=script&lang=js"
export * from "./Checkboard.vue?vue&type=script&lang=js"

import "./Checkboard.vue?vue&type=style&index=0&id=1af7c312&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__